export const inputHeight = "32px";
export const iconPadding = "30px";
